export const cameraMovements = new Map()

cameraMovements.set("initial", {
  positionX: -2,
  positionY: 2.3,
  positionZ: 1.5,
  lookAtX: 0.2,
  lookAtY: 2.8,
  lookAtZ: 2,
})

cameraMovements.set("section-entered", {
  positionX: -3,
  positionY: 3.3,
  positionZ: 2,
  lookAtX: 0,
  lookAtY: 2.8,
  lookAtZ: 0.5,
})

cameraMovements.set("section-end", {
  positionX: -4.4,
  positionY: 3.54,
  positionZ: 2.14,
  lookAtX: 0,
  lookAtY: 2.7,
  lookAtZ: 0,
})

cameraMovements.set("section-leaving", {
  positionX: 0,
  positionY: 3.5,
  positionZ: 7,
  lookAtX: 0,
  lookAtY: 1.75,
  lookAtZ: 0,
})

export const flashPattern = [
  [0.0, 2],
  [0.18, 20],
  [0.23, 4],
  [0.28, 18],
  [0.52, 5],
  [0.67, 22],
  [0.73, 3],
  [0.78, 19],
  [0.82, 4],
  [1.15, 24],
  [1.22, 5],
  [1.28, 20],
  [1.45, 3],
  [1.78, 18],
  [1.85, 4],
  [1.92, 22],
  [1.96, 3],
  [2.35, 20],
  [2.42, 5],
  [2.48, 18],
  [2.52, 4],
  [2.58, 24],
  [2.95, 3],
  [3.18, 22],
  [3.25, 4],
  [3.32, 19],
  [3.68, 5],
  [3.75, 20],
  [3.82, 3],
  [4.25, 18],
  [4.32, 4],
  [4.38, 24],
  [4.42, 5],
  [4.48, 20],
  [4.52, 3],
  [4.88, 22],
  [4.95, 4],
  [5.02, 18],
  [5.35, 5],
  [5.42, 20],
  [5.48, 3],
  [5.55, 24],
  [5.92, 4],
  [6.15, 19],
  [6.22, 5],
  [6.28, 22],
  [6.32, 3],
  [6.68, 18],
  [6.75, 4],
  [6.82, 20],
  [7.18, 5],
  [7.25, 24],
  [7.32, 3],
  [7.38, 19],
  [7.42, 4],
  [7.78, 22],
  [7.85, 5],
  [7.92, 18],
  [8.25, 3],
  [8.32, 20],
  [8.38, 4],
  [8.45, 24],
  [8.48, 5],
  [8.88, 19],
  [8.95, 3],
  [9.02, 22],
  [9.35, 4],
  [9.42, 18],
  [9.48, 5],
  [9.55, 20],
  [9.58, 3],
  [9.92, 24],
]
